import { Button, ButtonRow } from '@op/opds.opux';
import { Modal } from '@op/opds.opux-modal';
import { useState, useEffect} from 'react';
import { Message, useMessageGetter } from '@messageformat/react';

const KeepAlive = () => {
  const [headerName, setHeaderName] = useState(null);
  const [token, setToken] = useState(null);
  const [showError, setShowError] = useState(false);
  const [errorCount, setErrorCount] = useState(0);
  const offerRequestSubmitUrl = window?.INSURANCE_OFFER_REQUEST_SUBMIT_URL || ''
  const getMessage = useMessageGetter();
  
    // Fetch CSRF data
    useEffect(() => {
      const fetchCsrfData = async () => {
        try {
          const response = await fetch(offerRequestSubmitUrl+'/csrftokens', {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
          });
          if (!response.ok) {
            throw new Error(`Failed to fetch CSRF data (status ${response.status})`);
          }
          const jsonData = await response.json();
          if (jsonData && jsonData.headerName && jsonData.token) {
            setHeaderName(jsonData.headerName);
            setToken(jsonData.token);
          } else {
            throw new Error('Invalid CSRF data structure');
          }
        } catch (error) {
          console.error(error); // Log the error
          setShowError(true);
        }
      };
  
      fetchCsrfData();
    }, []);

  // Fetch health data periodically
  useEffect(() => {
    const fetchHealthData = async () => {
      try {
        if (headerName && token && errorCount <= 1) {
          const headers = {
            [headerName]: token,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          };
          const healthResponse = await fetch(offerRequestSubmitUrl+'/rest/insurance/offer/request/health', {
            headers,
          });
          if (!healthResponse.ok) {
            throw new Error(`Health check failed (status ${healthResponse.status})`);
          }
          setErrorCount(0); // Reset error count on successful response
        } else {
          console.error('CSRF data is missing or incomplete');
        }
      } catch (error) {
        console.error(error); // Log the error
        setErrorCount(prevCount => prevCount + 1);
      }
    };

    if (errorCount <= 1) {
        const healthInterval = setInterval(() => {
          (async () => {
            await fetchHealthData();
          })();
        }, 120000); // Fetch every 120 seconds
  
        return () => {
          clearInterval(healthInterval); // Clean up interval on component unmount
        };
      }
  }, [token, errorCount]);

   // Show error message if error count exceeds 1
   useEffect(() => {
    if (errorCount > 1) {
      setShowError(true);
    }
  }, [errorCount]);

  

  return (
    showError && <Modal
    appElement={document.getElementById('root')}
    footer={
      <div style={{ display: 'block', width: '100%' }}>
        <ButtonRow style={{ padding: 0 }}>
          <Button finish onClick={() => window.location.reload()}>
            <Message id="buttonText.okButton" />
          </Button>
        </ButtonRow>
      </div>
    }
    large
    isOpen = {true}
    title={getMessage('uiText.keepAliveModalTitle')}
    titleTagName="h4"
  >
    <p className="opux-v6__opds">
      <Message id="uiText.keepAliveModalBody" />
    </p>
  </Modal>
  );
};

export default KeepAlive;
